import type { IState, Actions } from './types'
import { Action } from './types'

const STOP = { played: 0, playedSeconds: 0, loaded: 0, loadedSeconds: 0 }

function reducer(state: IState, action: Actions): IState {
  switch (action.type) {
    case Action.PLAY:
      return { ...state, playing: true, started: true }
    case Action.SET_DURATION: {
      return { ...state, duration: action.payload }
    }
    case Action.PAUSE:
      return { ...state, playing: false }
    case Action.UPDATE:
      return { ...state, ...action.payload }
    case Action.TOGGLE_PLAY:
      return { ...state, playing: !state.playing, started: true }
    case Action.START_SEEKING:
      return { ...state, seeking: true, seekStartPosition: state.playedSeconds ?? 0 }
    case Action.SET_VOLUME:
      return { ...state, volume: action.payload }
    case Action.DECREASE_VOLUME: {
      const newVolume = Math.max(0, state.volume - 0.05)
      return { ...state, volume: parseFloat(newVolume.toFixed(2)) }
    }
    case Action.INCREASE_VOLUME: {
      const newVolume = Math.min(1, state.volume + 0.05)
      return { ...state, volume: parseFloat(newVolume.toFixed(2)) }
    }
    case Action.MUTE_TOGGLE: {
      return { ...state, muted: !state.muted }
    }
    case Action.SET_PLAYED: {
      const played = action.payload.playedSeconds / action.payload.duration
      return { ...state, played, playedSeconds: action.payload.playedSeconds }
    }
    case Action.TOGGLE_FULLSCREEN: {
      return { ...state, fullscreen: !state.fullscreen }
    }
    case Action.SET_FULLSCREEN: {
      return { ...state, fullscreen: action.payload }
    }
    case Action.SET_PLAYBACK_RATE: {
      return { ...state, playbackRate: action.payload }
    }
    case Action.SEEK_TO: {
      return { ...state, seeking: false, currentTime: action.payload, seekStartPosition: undefined }
    }
    case Action.SHOW_CC: {
      return { ...state, showCc: !state.showCc }
    }
    case Action.SET_PROGRESS:
      const { seeking, start, loop } = state
      const { loaded, loadedSeconds, played, playedSeconds, duration } = action.payload

      if (playedSeconds < start) {
        return { ...state, currentTime: playedSeconds }
      }

      if (playedSeconds >= duration + start) {
        return { ...state, ...STOP, playing: loop, currentTime: playedSeconds }
      }

      if (seeking) {
        return { ...state, currentTime: playedSeconds }
      }

      const p = played > 0 ? (playedSeconds - start) / duration : 0
      const pS = playedSeconds > 0 ? playedSeconds - start : 0
      const l = loaded ? (loadedSeconds - start) / duration : loaded
      const lS = loadedSeconds ? loadedSeconds - start : loadedSeconds
      const maxPlayedSeconds = Math.max(state.maxPlayedSeconds ?? 0, pS)

      return { ...state, played: p, playedSeconds: pS, loaded: l, loadedSeconds: lS, maxPlayedSeconds }

    default: {
      console.error(action)
      return state
    }
  }
}

export default reducer
